import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// Exportar facturas (InvoiceReport)
export async function exportInvoicesToExcel(invoices) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Facturas (Práctica)');

  // Agregar disclaimer
  worksheet.addRow(['Esta información es ficticia y se utiliza únicamente con fines prácticos. No representa datos reales. Versión de Práctica - Rama Practica.']);

  worksheet.columns = [
    { header: 'Número (Práctica)', key: 'numero', width: 20 },
    { header: 'Fecha (Práctica)', key: 'fecha', width: 15 },
    { header: 'Cliente (Práctica)', key: 'cliente', width: 30 },
    { header: 'Total (Práctica)', key: 'total', width: 15, style: { numFmt: '"RD$"#,##0.00' } },
    { header: 'Pagado (Práctica)', key: 'pagado', width: 15, style: { numFmt: '"RD$"#,##0.00' } },
    { header: 'Pendiente (Práctica)', key: 'pendiente', width: 15, style: { numFmt: '"RD$"#,##0.00' } },
    { header: 'Estado (Práctica)', key: 'estado', width: 15 }
  ];

  invoices.forEach(inv => {
    worksheet.addRow({
      numero: inv.invoiceNumber,
      fecha: inv.invoiceDate ? new Date(inv.invoiceDate).toLocaleDateString() : '',
      cliente: inv.clientName,
      total: inv.totalAmount,
      pagado: inv.paidAmount,
      pendiente: inv.pendingAmount,
      estado: inv.paymentStatus
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'reporte_facturas_practica.xlsx');
}

// Exportar pagos mensuales (MonthlyPaymentReport)
export async function exportMonthlyPaymentsToExcel(payments) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Pagos Mensuales (Práctica)');

  // Agregar disclaimer
  worksheet.addRow(['Esta información es ficticia y se utiliza únicamente con fines prácticos. No representa datos reales. Versión de Práctica - Rama Practica.']);

  worksheet.columns = [
    { header: 'Fecha (Práctica)', key: 'fecha', width: 18 },
    { header: 'Factura (Práctica)', key: 'factura', width: 15 },
    { header: 'Cliente (Práctica)', key: 'cliente', width: 30 },
    { header: 'Método (Práctica)', key: 'metodo', width: 15 },
    { header: 'Monto (Práctica)', key: 'monto', width: 15, style: { numFmt: '"RD$"#,##0.00' } },
    { header: 'Descripción (Práctica)', key: 'descripcion', width: 30 },
    { header: 'Atendido por (Práctica)', key: 'empleado', width: 20 }
  ];

  payments.forEach(p => {
    worksheet.addRow({
      fecha: p.paymentDate ? new Date(p.paymentDate).toLocaleString() : '',
      factura: p.invoiceNumber,
      cliente: p.clientName,
      metodo: p.paymentMethod,
      monto: p.amount,
      descripcion: p.description,
      empleado: p.employeeName
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'reporte_pagos_mensuales_practica.xlsx');
}

// Exportar pagos diarios (DailyPaymentReport)
export async function exportDailyPaymentsToExcel(payments) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Pagos Diarios (Práctica)');

  // Agregar disclaimer
  worksheet.addRow(['Esta información es ficticia y se utiliza únicamente con fines prácticos. No representa datos reales. Versión de Práctica - Rama Practica.']);

  worksheet.columns = [
    { header: 'Fecha (Práctica)', key: 'fecha', width: 18 },
    { header: 'Factura (Práctica)', key: 'factura', width: 15 },
    { header: 'Cliente (Práctica)', key: 'cliente', width: 30 },
    { header: 'Método (Práctica)', key: 'metodo', width: 15 },
    { header: 'Monto (Práctica)', key: 'monto', width: 15, style: { numFmt: '"RD$"#,##0.00' } },
    { header: 'Descripción (Práctica)', key: 'descripcion', width: 30 },
    { header: 'Atendido por (Práctica)', key: 'empleado', width: 20 }
  ];

  payments.forEach(p => {
    worksheet.addRow({
      fecha: p.creationDate ? new Date(p.creationDate).toLocaleString() : '',
      factura: p.invoiceNumber,
      cliente: p.clientName,
      metodo: p.paymentMethod,
      monto: p.amount,
      descripcion: p.description,
      empleado: p.employeeName
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'reporte_pagos_diarios_practica.xlsx');
}